// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2866":"1df9cff0","3831":"ea5a449b","3883":"a0b9c79d","6960":"5556c092","7079":"a0b9c79d","8451":"5556c092","9447":"c9cb3028"}[chunkId] + ".chunk.css";
};